import React from "react";
import styled from "styled-components";
import I10n from '../../features/i10n';
import MsxIcons from '../../features/msx-icons';
import PropTypes from 'prop-types';
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../color-constants";

const InnerBubble = styled.div`
  position: relative;
  z-index: 3;
  background-color: ${SECONDARY_COLOR};
  background-color: var(--se-primary, ${SECONDARY_COLOR});
  border-radius: 50%;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  width: 28px;
  height: 28px;
  transition: all 250ms;
`;

const InnerSquare = styled.div`
  position: absolute;
  z-index: 4;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 50%;
  background-color: ${SECONDARY_COLOR};
  background-color: var(--se-primary, ${SECONDARY_COLOR});
  transition: all 250ms;
`;

const IconWrapper = styled.div`
  position: absolute;
  left: 2px;
  top: 2px;
  z-index: 5;
  color: white;
  color: var(--se-primary-contrast, white);
  transition: all 250ms;
`;

const Container = styled.div`
  box-sizing: content-box;
  position: relative;
  padding: 10px 20px 10px 30px;
  border-radius: 16px 16px 0px 0px;

  background-color: ${SECONDARY_COLOR};
  background-color: var(--se-primary, ${SECONDARY_COLOR});
  color: white;
  color: var(--se-primary-contrast, white);
  transition: all 250ms;

  cursor: pointer;

  :hover {
    background-color: ${PRIMARY_COLOR};
    background-color: var(--se-secondary, ${PRIMARY_COLOR});
    color: white;
    color: var(--se-secondary-contrast, white);
    ${InnerBubble} {
      background-color: ${PRIMARY_COLOR};
      background-color: var(--se-secondary, ${PRIMARY_COLOR});
    }
    ${InnerSquare} {
      background-color: ${PRIMARY_COLOR};
      background-color: var(--se-secondary, ${PRIMARY_COLOR});
    }
    ${IconWrapper} {
      color: white;
      color: var(--se-secondary-contrast, white);
    }
  }

  ${props => props.disabled ? 'pointer-events: none; opacity: 0.5;' : ''}
`;

const Label = styled.div`
  font-weight: 700;
  font-size: 16px;
`;

const BubblePositioner = styled.div`
  position: absolute;
  left: -10px;
  top: -8px;
  right: 0px;
  z-index: 1;
`;

const WrapperBubble = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  max-width: 36px;
  max-height: 36px;
  background-color: white;
  padding: 4px;
  border-radius: 50%;
`;

const WrapperSquare = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 50%;
  background-color: white;
`;

class LicenceSelectorHMCToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }

  static propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func
  }

  render = () => {
    return (
      <Container disabled={this.props.disabled} onClick={() => { this.props.onClick(); }} onMouseOver={() => { this.setState({ hover: true }); }} onMouseLeave={() => { this.setState({ hover: false }); }}>
        <Label>{I10n.get(this.state.hover ? 'screen.licence_selector.try_configuration_assistant' : 'screen.licence_selector.help')}</Label>
        <BubblePositioner>
          <WrapperBubble>
            <WrapperSquare></WrapperSquare>
            <InnerBubble>
              <IconWrapper>
                <MsxIcons name="about"></MsxIcons>
              </IconWrapper>
              <InnerSquare></InnerSquare>
            </InnerBubble>
          </WrapperBubble>
        </BubblePositioner>
      </Container>
    );
  }
}

export default LicenceSelectorHMCToggle;
